// Attitude strip: pitch, roll and yaw, slaved to the profile.
//
// Pitch and roll share one symmetric axis with zero down the middle, so a bank
// or a nose-down reads at a glance against the centre line. Yaw is heading, not
// a deflection from level, so it sits on its own faint trace — and because it
// wraps through the +/-180 seam, the line is broken there rather than streaking
// the full height of the strip each time the nose passes south.

import { Strip } from './strip.js';

export class AttitudeChart extends Strip {
  storageKey() { return 'ddlv-attitude-series'; }
  ariaLabel() { return 'Attitude timeline'; }

  series() {
    const span = `\u00b1${this.attSpan()}\u00b0`;
    return [
      { id: 'yaw', key: 'yawDeg', label: 'yaw', unit: '\u00b0', colour: 'var(--trace)', min: -180, max: 180, wrap: true, opacity: 0.55, fmt: (v) => `${Math.round(v)}` },
      { id: 'pitch', key: 'pitchDeg', label: 'pitch', unit: span, colour: 'var(--ok)', sym: true, opacity: 0.9, fmt: (v) => `${Math.round(v)}` },
      { id: 'roll', key: 'rollDeg', label: 'roll', unit: span, colour: 'var(--amber)', sym: true, opacity: 0.9, fmt: (v) => `${Math.round(v)}` },
    ];
  }

  // The symmetric pitch/roll half-span, computed straight from the columns so
  // it can be baked into the labels without recursing through series().
  attSpan() {
    let m = 0;
    for (const key of ['pitchDeg', 'rollDeg']) {
      const values = this.flight.cols[key];
      if (!values) continue;
      for (const v of values) if (v !== null && Math.abs(v) > m) m = Math.abs(v);
    }
    return Math.max(this.symFloor(), Math.ceil(m));
  }

  // Zero reference for the symmetric pitch/roll axis, drawn behind the traces.
  underlay(geom, width) {
    const mid = (geom.padTop + geom.plotHeight / 2).toFixed(1);
    return `<line x1="0" y1="${mid}" x2="${width}" y2="${mid}"
        stroke="var(--rule)" stroke-width="1" vector-effect="non-scaling-stroke" opacity="0.6" />`;
  }
}
